// apps/client/src/net/limiter.ts — client-side mirrors of the server limits
import { tuning } from '@whiskerton/content';
import type { MoveState } from '@whiskerton/shared';

export class TokenBucket {                                      // the same algorithm as server:town/limits.ts
  private tokens: number;
  private last: number;
  private readonly perSec: number;
  private readonly burst: number;
  constructor(perSec: number, burst: number, now: number) { this.perSec = perSec; this.burst = burst; this.tokens = burst; this.last = now; }
  take(now: number): boolean {
    this.tokens = Math.min(this.burst, this.tokens + ((now - this.last) / 1000) * this.perSec);
    this.last = now;
    if (this.tokens < 1) return false;
    this.tokens -= 1;
    return true;
  }
}
/** Send at moveSendHz only while moving or when the animation changes, plus one final idle frame (§4.7). */
export class MoveThrottle {
  private lastAt = -Infinity;
  private last: MoveState | null = null;
  private readonly gap: number;
  constructor(hz: number = tuning.net.moveSendHz) { this.gap = 1000 / hz; }
  /** `admit` (the socket's hard cap) runs only when the throttle wants to send. The state is remembered only once admitted, so a
   *  frame the cap refuses (say the final idle one) is retried on the next frame instead of being lost. */
  shouldSend(now: number, s: MoveState, admit?: (now: number) => boolean): boolean {
    const l = this.last;
    const changed = !l || l.a !== s.a || l.tool !== s.tool;
    const moving = !!l && (Math.abs(l.x - s.x) > 1e-3 || Math.abs(l.y - s.y) > 1e-3 || Math.abs(l.f - s.f) > 1e-2);
    if (!changed && !moving) return false;
    if (!changed && now - this.lastAt < this.gap) return false;
    if (admit && !admit(now)) return false;
    this.last = { ...s }; this.lastAt = now;
    return true;
  }
  /** After a correction or a space change the next state is always sent. */
  reset(): void { this.last = null; this.lastAt = -Infinity; }
}
